<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text: 'Elementy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: get(item, ['title_en']),
                  fields: [
                    new fields.Input({
                      label: 'Tytuł',
                      modelPath: [this, 'form', 'items', i, 'title'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Treść',
                      type: 'textarea',
                      modelPath: [this, 'form', 'items', i, 'content'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
